module.exports = __webpack_public_path__ + "static/media/zu.7b13be11.png";